import { ActionTree } from "vuex";
import { campaignsRoute, clientLeadsRoute, leadClientsRoute, leadsRoute } from "@/router";
import { MenuLink, UserData } from "@/models/UserData";
import { MainState } from "@/models/states/MainState";
import { RootState } from "@/models/states/RootState";
import ApiService from "@/services/api/ApiService";

const actions: ActionTree<MainState, RootState> = {
  getUserData({ commit }): Promise<UserData> {
    return new Promise((resolve, reject) => {
      ApiService.getUserData()
        .then((data: UserData) => {
          if (data.MenuLinks) {
            data.MenuLinks.map((menuLink: MenuLink) => {
              menuLink.IsOldLink = [
                campaignsRoute,
                clientLeadsRoute,
                leadClientsRoute,
                leadsRoute,
                "/Phones/Index",
              ].indexOf(menuLink.Href) === -1;
            });
          }
          commit("setUserData", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setUserData({ commit }, userData: UserData): void {
    commit("setUserData", userData);
  },
};
export default actions;
